// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
export default 'void main() {fragColor=vec4(1.0);}';
